'use strict';

const saSupportPhoneNumber = [
  'config',

  function (config) {
    return {
      template: '<a class="Link Link--blue" ng-href="{{::\'tel://\' + ctrl.phoneNumberLink}}">{{::ctrl.phoneNumber}}</a>',
      replace: true,
      scope: {},
      bindToController: true,
      controllerAs: 'ctrl',
      controller: [
        function () {
          this.phoneNumber = config.supportPhoneNumber;
          this.phoneNumberLink = config.supportPhoneNumber.replace(/\s/g, '');
        }
      ]
    };
  }
];

export default saSupportPhoneNumber;



// WEBPACK FOOTER //
// ./app/src/directives/support_phone_number.js